<div class="d-flex flex-column ws-flex-auto min-height-0">
    <ws-bread-crumbs [breadcrumbs]="breadcrumbs" currentPageTitle="Contract Terms"></ws-bread-crumbs>
    <div class="ws-section">
        <div class="ws-section__header">
            <h4 class="ws-section__header__title page-title">Contract Terms</h4>
            <div class="ws-section__header__actions">
                @if (!editMode && !editLock && !isLoading) {
                    <div class="ws-section__header__actions__item">
                        <div class="d-flex align-items-center">
                            <span class="me-1">Tax Year:</span>
                            <!-- Do not change the order of ngModelChange and ngModel! It will change functionality for some weird reason (that I'm using to my advantage) -->
                            <select (ngModelChange)="yearChanged()"
                                    [(ngModel)]="selectedYear"
                                    data-qa="contract-terms-year-filter"
                                    class="form-select form-select-sm form-select-nb d-inline-block w-auto">
                                <option value="0" data-qa="contract-terms-year-0">All</option>
                                @for (year of (useTopLevelCompanyTerms ? topLevelYears : subsidiaryYears); track year; let i = $index) {
                                    <option [value]="year" [attr.data-qa]="'contract-terms-year-' + (i + 1)">{{ year }}</option>
                                }
                            </select>
                        </div>
                    </div>
                }
                @if (!isEditMode && !editLock && hasEditPermission) {
                    <div class="ws-section__header__actions__item">
                        <button class="ace-btn btn-sm btn-primary has-icon" data-qa="contract-terms-edit" (click)="goToEditMode()">
                            <i class="fa fa-pencil"></i>
                        </button>
                    </div>
                }
                @if (termsAreEditable()) {
                    <div class="ws-section__header__actions__item">
                        <button class="ace-btn btn-sm btn-primary" data-qa="contract-terms-add-term" (click)="addTerm()">Add Term</button>
                    </div>
                }
                @if (showRollForwardYearButton()) {
                    <div class="ws-section__header__actions__item">
                        <button class="ace-btn btn-sm btn-primary" style="margin-left:10px;"
                                data-qa="contract-terms-roll-forward-year"
                                (click)="rollForwardYear()">Roll Forward Year
                        </button>
                    </div>
                }
                @if (isEditMode) {
                    <div class="ws-section__header__actions__item">
                        <button class="ace-btn btn-sm btn-primary has-icon"
                                data-qa="contract-terms-save"
                                (click)="savePanel()"
                                [disabled]="isLoading">
                            <i class="fa fa-save"></i>
                        </button>
                        <button class="ace-btn btn-sm btn-primary btn-danger has-icon"
                                data-qa="contract-terms-cancel"
                                (click)="cancelEdit()">
                            <i class="fa fa-close"></i>
                        </button>
                    </div>
                }
            </div>
        </div>
    </div>
    <div class="ws-section flex-grow-1 bg-white py-3 px-2 ace-radius position-relative min-height-0">
        @if (isLoading) {
            <ws-ace-loader [hideLabel]="false"></ws-ace-loader>
        } @else {
            @if (!isTopLevel || isEditMode) {
                <div class="checkbox text-end" [class.disabled]="!isEditMode" style="margin-top: 0;">
                    @if (isEditMode && (isTopLevel || !useTopLevelCompanyTerms)) {
                        <span class="anchor-style" (click)="configureFeeEscalator()" data-qa="contract-terms-configure-fee-escalator">
                                    @if (allData.feeEscalator) {
                                        <span>
                                            Annual Fixed Fee
                                            Escalator: {{ allData.feeEscalator * 100 | number: '1.2' }}%
                                        </span>
                                    }
                            @if (!allData.feeEscalator) {
                                <span>Configure Annual Fixed Fee Escalator</span>
                            }
                            </span>
                    }
                    @if (!isTopLevel) {
                        <label style="margin-left: 1em;">
                            <input type="checkbox"
                                   [(ngModel)]="useTopLevelCompanyTerms"
                                   [disabled]="!isEditMode"
                                   (change)="useTopLevelCompanyChanged()"
                                   data-qa="contract-terms-use-top-level-company-terms">
                            Use Top Level Company Terms
                        </label>
                    }
                </div>
            }
            <table class="ace-table contract-terms">
                <thead>
                <tr>
                    <th>Service</th>
                    <th>Property Type</th>
                    <th class="text-center">Tax Year</th>
                    <th>Terms</th>
                    <th></th>
                    <th></th>
                    <th class="text-center">Engagement #</th>
                    <th></th>
                    <th class="text-center">Site Default</th>
                    <th></th>
                </tr>
                </thead>
                @if (!isEditMode || useTopLevelCompanyTerms) {
                    <tbody class="contract-terms-view">
                        @for (term of (useTopLevelCompanyTerms ? topLevelCompanyContractTerms : currentContractTerms); track term; let
                            i = $index) {
                            <tr>
                                <td>{{ term.contractServiceTypeName }}</td>
                                <td>{{ term.propertyTypeName }}</td>
                                <td class="text-center">{{ term.taxYear }}</td>
                                <td>
                                    <term-rates-and-fees [term]="term"></term-rates-and-fees>
                                </td>
                                <td></td>
                                <td class="text-center">
                                    @if (term.remarks) {
                                        <button
                                            class="ace-btn has-icon btn-primary"
                                            (click)="showComments(term, true)"
                                            style="margin-left:0.5em;"
                                            [title]="term.remarks"
                                            [attr.data-qa]="'contract-terms-view-comment-' + i">
                                            <i class="fa fa-commenting"></i>
                                        </button>
                                    }
                                </td>
                                <td class="text-center">{{ term.engagement }}</td>
                                <td></td>
                                <td class="text-center">
                                    <div class="checkbox" style="margin: 0;">
                                        <label>
                                            <input type="checkbox" [(ngModel)]="term.siteDefault" disabled [attr.data-qa]="'contract-terms-view-site-default-' + i">
                                        </label>
                                    </div>
                                </td>
                                <td></td>
                            </tr>
                        }
                    </tbody>
                }
                @if (termsAreEditable()) {
                    <tbody class="contract-terms-edit">
                        @for (term of currentContractTerms; track term; let i = $index) {
                            @if (term.efAction !== 'delete') {
                                <tr class="delete-hover">
                                    <td>
                                        <select [(ngModel)]="term.contractServiceTypeId"
                                                class="form-select form-select-sm"
                                                [disabled]="!!term.contractTermDetailId"
                                                (ngModelChange)="serviceTypeChanged($event, term)"
                                                [attr.data-qa]="'contract-terms-edit-service-type-' + i">
                                            @for (service of services; track service; let j = $index) {
                                                <option [ngValue]="service.id" [attr.data-qa]="'contract-terms-edit-service-type-option-' + i + '-' + j">{{ service.name }}</option>
                                            }
                                        </select>
                                    </td>
                                    <td>
                                        <select [(ngModel)]="term.propertyTypeId"
                                                class="form-select form-select-sm"
                                                [disabled]="term.contractServiceTypeId !== ContractServiceType.Appeal && term.contractServiceTypeId !== ContractServiceType.Litigation && term.contractServiceTypeId !== ContractServiceType.LitigationAdmin && term.contractServiceTypeId !== ContractServiceType.LitigationOnly || !!term.contractTermDetailId"
                                                [attr.data-qa]="'contract-terms-edit-property-type-' + i">
                                            <option [ngValue]="null" [attr.data-qa]="'contract-terms-edit-property-type-option-' + i + '-0'">All</option>
                                            @for (type of propertyTypes; track type; let j = $index) {
                                                <option [ngValue]="type.propertyTypeId" [attr.data-qa]="'contract-terms-edit-property-type-option-' + i + '-' + (j + 1)">{{ type.name }}</option>
                                            }
                                        </select>
                                    </td>
                                    <td>
                                        <select [(ngModel)]="term.taxYear"
                                                class="form-select form-select-sm mx-auto"
                                                [disabled]="!!term.contractTermDetailId"
                                                style="width: auto;"
                                                [attr.data-qa]="'contract-terms-edit-tax-year-' + i">
                                            @for (year of recentYears; track year; let j = $index) {
                                                <option [ngValue]="year" [attr.data-qa]="'contract-terms-edit-tax-year-option-' + i + '-' + j">{{ year }}</option>
                                            }
                                        </select>
                                    </td>
                                    <td style="width: 1%; white-space: nowrap;">
                                        <term-rates-and-fees [term]="term"></term-rates-and-fees>
                                    </td>
                                    <td style="width: 1px;">
                                        <choose-term-popover [selectedTerm]="term"></choose-term-popover>
                                    </td>
                                    <td class="text-center">
                                        <button class="ace-btn btn-sm has-icon btn-primary"
                                                (click)="showComments(term, false)"
                                                [attr.data-qa]="'contract-terms-edit-comment-' + i">
                                            @if (term.remarks) {
                                                <i class="fa fa-commenting"></i>
                                            }
                                            @if (!term.remarks) {
                                                <i class="fa fa-comment-o"></i>
                                            }
                                        </button>
                                    </td>
                                    <td class="text-center" style="width: 1px;">
                                        <span>{{ term.engagement }}</span>
                                    </td>
                                    <td style="width: 1px;">
                                        <div helpTooltip
                                             tooltipText="Select Engagement Number">
                                            <button class="ace-btn btn-sm has-icon btn-primary"
                                                    (click)="lookupEngagement(term)"
                                                    [attr.data-qa]="'contract-terms-edit-lookup-engagement-' + i">
                                                <i class="fa fa-binoculars"></i>
                                            </button>
                                        </div>
                                    </td>
                                    <td class="text-center">
                                        <div class="checkbox" style="margin: 0;">
                                            <label>
                                                <input type="checkbox"
                                                       [(ngModel)]="term.siteDefault"
                                                       [disabled]="term.contractServiceTypeId === ContractServiceType.Misc || term.contractServiceTypeId === ContractServiceType.Hourly"
                                                       [attr.data-qa]="'contract-terms-edit-site-default-' + i">
                                            </label>
                                        </div>
                                    </td>
                                    <td>
                                        <div helpTooltip
                                             tooltipText="Remove Term">
                                            <button class="ace-btn btn-sm btn-primary btn-danger has-icon m-0"
                                                    (click)="removeTerm(term, i)"
                                                    [attr.data-qa]="'contract-terms-edit-remove-' + i">
                                                <i class="fa fa-close"
                                                ></i>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            }
                        }
                    </tbody>
                }
            </table>
        }
    </div>
</div>

